<template>
    <b-container class="d-flex flex-column mw-100 mh-100 h-100 m-0 p-0 overflow-auto flex-wrap">
        <!-- Présentation du calendrier en jour -->
        <FactorCalendarDay v-if="CalendarType == factorCalendarTypeEnum.Day"
                           :SelectedDate="SelectedDate"
                           :Data="Data"
                           :HoverDatas.sync="hoverDatas"
                           :SelectedFactor="SelectedFactor"
                           :Variant="Variant"
                           :ColorCaclulateData="colorCaclulateData"
                           :ColorNotCaclulateData="colorNotCaclulateData"
                           :ShowDatas.sync="showDatas"
                           :ShowModal.sync="showModal"
                           :StartPeriod.sync="startPeriod"
                           :EndPeriod.sync="endPeriod"/>

        <!-- Présentation du calendrier en semaine -->
        <FactorCalendarWeek v-if="CalendarType == factorCalendarTypeEnum.Week"
                                :SelectedDate="SelectedDate"
                                :Data="Data" :OuterData="OuterData"
                                :HoverDatas.sync="hoverDatas"
                                :SelectedFactor="SelectedFactor"
                                :Variant="Variant"
                                :ColorCaclulateData="colorCaclulateData"
                                :ColorNotCaclulateData="colorNotCaclulateData"
                                :ShowDatas.sync="showDatas"
                                :ShowModal.sync="showModal"
                                :StartPeriod.sync="startPeriod"
                                :EndPeriod.sync="endPeriod"/>

        <!-- Présentation du calendrier en mois -->
        <FactorCalendarMonth v-if="CalendarType == factorCalendarTypeEnum.Month"
                             :SelectedDate="SelectedDate"
                             :Data="Data" :OuterData="OuterData"
                             :HoverDatas.sync="hoverDatas"
                             :SelectedFactor="SelectedFactor"
                             :Variant="Variant"
                             :ColorCaclulateData="colorCaclulateData"
                             :ColorNotCaclulateData="colorNotCaclulateData"
                             :ShowDatas.sync="showDatas"
                             :ShowModal.sync="showModal"
                             :StartPeriod.sync="startPeriod"
                             :EndPeriod.sync="endPeriod"/>

        <!-- Présentation du calendrier en semestre -->
        <FactorCalendarSemester v-if="CalendarType == factorCalendarTypeEnum.Semester"
                                :SelectedDate="SelectedDate"
                                :Data="Data" :OuterData="OuterData"
                                :HoverDatas.sync="hoverDatas"
                                :SelectedFactor="SelectedFactor"
                                :Variant="Variant"
                                :ColorCaclulateData="colorCaclulateData"
                                :ColorNotCaclulateData="colorNotCaclulateData"
                                :ShowDatas.sync="showDatas"
                                :ShowModal.sync="showModal"
                                :StartPeriod.sync="startPeriod"
                                :EndPeriod.sync="endPeriod"/>

        <!-- Popover pour pour la temporalité 'indexée' et 'instantanée' -->
        <b-row class="p-0 pl-3 pr-4 m-0 h-100 w-100 position-absolute" align-h="end"
               :align-v="hoverDatas?.length > 0 &&
                        ((CalendarType == factorCalendarTypeEnum.Month && hoverDatas[0].noStep > 15) ||
                        (CalendarType == factorCalendarTypeEnum.Day && hoverDatas[0].noStep > 12))
                        ? 'start' : 'end'"
               :align-h="hoverDatas?.length > 0 &&
                        ((CalendarType == factorCalendarTypeEnum.Month && hoverDatas[0].noStep > 15) ||
                        (CalendarType == factorCalendarTypeEnum.Day && hoverDatas[0].noStep > 12))
                        ? 'start' : 'end'"
               v-if="SelectedFactor?.Temporality != 1 &&
                    (CalendarType == factorCalendarTypeEnum.Month || CalendarType == factorCalendarTypeEnum.Day)"
               style="pointer-events: none;">
            <b-col class="m-0 p-0" style="z-index: 100; pointer-events: none;" md="auto">
                <b-row class="border bg-white rounded" :class="'border-' + Variant"
                       :hidden="hoverDatas?.length == 0" align-h="end">
                    <b-col class="m-0 p-0">
                        <template v-for="(data, index) in hoverDatas">
                            <template v-if="data != undefined">
                                <b-row class="m-0 p-0" align-h="end">
                                    <div class="m-0 d-flex flex-row flex-wrap" text-variant="dark"
                                         :class="data.lenghtMinutesValue > 0 ? ' px-1 pt-1 ' : 'p-1'">
                                        <div class="d-flex mt-1 p-0">
                                            <div class="flex-column border p-1 m-0 text-center"
                                                 :class="'border-' + colorNotCaclulateData[data.periodicity]">
                                                {{ getMomentDateToString(data.startData.date, true) }}
                                            </div>
                                            <!--<div class="left-arrow"
                                                 :class="'bg-' + colorNotCaclulateData[data.periodicity]"></div>-->
                                            <div
                                                class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                :class="'bg-' + colorNotCaclulateData[data.periodicity]">
                                                <span class="d-flex align-items-center h-100 mh-100">
                                                    {{ data.startData.value != undefined ?
                                                        Intl.NumberFormat('fr-FR').format(data.startData.value) :
                                                        data.startData.value }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <template v-if="data.lenghtMinutesValue > 0">
                                    <b-row class="m-0 p-0 px-1">
                                        <b-col cols="auto" class="mr-auto"></b-col>
                                        <b-col cols="auto">
                                            <b-row class="m-0 p-0 w-100 mw-100" align-h="end">
                                                <b-col class="m-0 p-0 w-100 mw-100 top-arrow"
                                                       style="height: 1rem"
                                                       :class="'bg-' + colorNotCaclulateData[data.periodicity]">
                                                </b-col>
                                            </b-row>
                                            <b-row class="m-0 p-0" align-h="end" text-variant="dark">
                                                <div
                                                    class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                    :class="'bg-' + colorNotCaclulateData[data.periodicity]">
                                                    <span class="d-flex align-items-center h-100 mh-100">
                                                    {{ data.value != undefined ?
                                                        Intl.NumberFormat('fr-FR').format(data.value) :
                                                        data.value }}
                                                    </span>
                                                </div>
                                            </b-row>
                                            <b-row class="m-0 p-0 w-100 mw-100" align-h="end">
                                                <b-col class="m-0 p-0 w-100 mw-100 bottom-arrow"
                                                       style="height: 1rem"
                                                       :class="'bg-' + colorNotCaclulateData[data.periodicity]">
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row class="m-0 p-0" align-h="end">
                                        <div class="m-0 px-1 pb-1 d-flex flex-row flex-wrap" text-variant="dark">
                                            <div class="d-flex mb-1 mx-1 p-0">
                                                <div class="flex-column border p-1 m-0 text-center"
                                                     :class="'border-' + colorNotCaclulateData[data.periodicity]">
                                                    {{ getMomentDateToString(data.endData.date, true) }}
                                                </div>
                                                <!--<div class="left-arrow"
                                                     :class="'bg-' + colorNotCaclulateData[data.periodicity]"></div>-->
                                                <div
                                                    class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                    :class="'bg-' + colorNotCaclulateData[data.periodicity]">
                                                <span class="d-flex align-items-center h-100 mh-100">
                                                    {{ data.endData.value != undefined ?
                                                        Intl.NumberFormat('fr-FR').format(data.endData.value) :
                                                        data.endData.value }}
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-row>
                                </template>
                            </template>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <!-- Modale pour la modification des valeurs -->
        <b-modal v-model="showModal" centered @show="changeData(undefined)"
                 v-if="$store.getters['CheckAction']('Write', undefined, Action)"
                 no-close-on-backdrop no-close-on-esc id="bv-modal-calendar" size="lg"
                 :title="showDatas.length == 1 && showDatas[0].Status == 0? $t('NewValue') :
                        $t('Value') + (showDatas.length > 1 ? 's' : '') + $t('OfTheFactor')">
            <b-form v-for="(data, index) in showDatas" :key="index" @submit.stop.prevent>
                <b-card class="p-2 w-100 bg-white" v-if="data.Status != -1"
                        :body-class="'p-2 border rounded shadow-sm border-' + colorNotCaclulateData[data.Periodicity]">
                    <b-card-header role="tab" header-tag="header" @click="data.Collapsed = !data.Collapsed;
                            showDatas.length > index + 1 ? showDatas[index + 1].Collapsed = true : true"
                                   class="text-center font-weight-bold p-0 mx-0 w-100 bg-white">
                        <b-row class="m-0 p-0 w-100">
                            <b-col class="text-left m-0 p-0" md="auto">
                                <template v-if="!data.Collapsed">
                                    <div class="m-0 p-1 d-flex flex-row flex-wrap" text-variant="dark">
                                        <div class="d-flex m-1 p-0">
                                            <div class="flex-column border p-1 m-0 text-center"
                                                 :class="'border-' + colorNotCaclulateData[data.Periodicity]">
                                                {{ getMomentDateToString(data.StartDate + ' ' + data.StartTime, true) }}
                                            </div>
                                            <div class="left-arrow" v-if="SelectedFactor?.Temporality == 1"
                                                 :class="'bg-' + colorNotCaclulateData[data.Periodicity]"></div>
                                            <div
                                                class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                :class="'bg-' + colorNotCaclulateData[data.Periodicity] +
                                              ' border-' + colorNotCaclulateData[data.Periodicity]">
                                                    <span class="d-flex align-items-center h-100 mh-100">
                                                        {{ data.Value != undefined ?
                                                            Intl.NumberFormat('fr-FR').format(data.Value) :
                                                            data.Value }}
                                                    </span>
                                            </div>
                                            <div class="right-arrow" v-if="SelectedFactor?.Temporality == 1"
                                                 :class="'bg-' + colorNotCaclulateData[data.Periodicity] +
                                              ' border-' + colorNotCaclulateData[data.Periodicity]"></div>
                                            <div class="p-1 m-0 border text-center"
                                                 v-if="SelectedFactor?.Temporality == 1"
                                                 :class="'border-' + colorNotCaclulateData[data.Periodicity]">
                                                {{ getMomentDateToString(data.EndDate + ' ' + data.EndTime, false) }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </b-col>
                            <b-col class="d-flex justify-content-end m-0 p-0">
                                <b-button v-if="data.Collapsed && showDatas.length > 1" size="sm"
                                          class="border-0 bg-white text-black">
                                    <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5"
                                            role="button"/>
                                </b-button>
                                <b-button size="sm" class="border-0 bg-white text-black"
                                          v-if="!data.Collapsed && showDatas.length > 1">
                                    <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5"
                                            role="button"/>
                                </b-button>

                                <b-button v-if="showDatas.length > 1" size="sm" class="border-0 bg-white"
                                          :disabled="!$store.getters['CheckAction']('Delete', undefined, Action)">
                                    <b-icon icon="x-lg" v-b-tooltip.hover :title="$t('EraseData')"
                                            @click.stop="deleteData(data.DataId)" class="text-danger"/>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-collapse v-model="data.Collapsed" accordion="dataAccordion">
                        <b-card-body class="m-0 p-1">
                            <b-card class="bg-transparent" body-class="m-0 p-0"
                                header-class="bg-transparent m-0 px-0 py-1">
                                <template #header>
                                    <h6>
                                        {{ SelectedFactor?.Temporality == 1 ? $t('Dates') : $t('Date') }}
                                        <b-badge v-b-tooltip.hover
                                                 :title="$t('DontFillDates')"
                                                 circle class="align-self-center ml-2">
                                            <b-icon font-scale="1.5" icon="info" />
                                        </b-badge>
                                    </h6>
                                </template>
                                <b-row class="w-100 h-100 m-0 p-0" align-v="center">
                                    <b-col class="m-0 p-0">
                                        <b-form-group
                                            :label="SelectedFactor?.Temporality == 1 ? $t('StartDate') + ' :' : ''"
                                            class="p-0 m-0" :label-for="$id('startDate')">
                                            <b-row class="p-0 m-0">
                                                <b-col class="p-0 m-0">
                                                    <b-input-group>
                                                        <b-form-input
                                                            :id="$id('startDate')"
                                                            v-model="data.StartDate"
                                                            button-only
                                                            right
                                                            locale="fr"
                                                            size="sm"
                                                            type="date"
                                                            @change="changeData(data.DataId)">
                                                        </b-form-input>
                                                        <b-form-input
                                                            :id="$id('startTime')"
                                                            v-model="data.StartTime"
                                                            button-only
                                                            right
                                                            locale="fr"
                                                            size="sm"
                                                            type="time"
                                                            @change="changeData(data.DataId)">
                                                        </b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :variant="'outline-' + Variant"
                                                                      @click.stop="data.StartTime = '';data.StartDate = '';changeData(data.DataId)">
                                                                <b-icon icon="eraser"/>
                                                            </b-button >
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-col>
                                    <b-col class="m-0 p-0 pl-2" v-if="SelectedFactor?.Temporality == 1">
                                        <b-form-group :label="$t('EndDate') + ' :'" class="p-0 m-0" :label-for="$id('endDate')">
                                            <b-row class="m-0 p-0">
                                                <b-col class="m-0 p-0">
                                                    <b-input-group>
                                                        <b-form-input
                                                            :id="$id('endDate')"
                                                            v-model="data.EndDate"
                                                            button-only
                                                            right
                                                            locale="fr"
                                                            size="sm"
                                                            type="date"
                                                            @change="changeData(data.DataId)">
                                                        </b-form-input>
                                                        <b-form-input
                                                            :id="$id('endTime')"
                                                            v-model="data.EndTime"
                                                            button-only
                                                            right
                                                            locale="fr"
                                                            size="sm"
                                                            type="time"
                                                            @change="changeData(data.DataId)">
                                                        </b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :variant="'outline-' + Variant"
                                                                      @click.stop="data.EndTime = '';data.EndDate = '';changeData(data.DataId)">
                                                                <b-icon icon="eraser"/>
                                                            </b-button >
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card :title="$t('Periodicity')" class="bg-transparent" body-class="m-0 p-0 pt-3"
                                    v-if="SelectedFactor?.FactorType != 2" title-tag="h6">
                                <b-row class="w-100 h-100 m-0 p-0 align-items-center" align-v="center" align-h="center">
                                    <b-col class="m-0 p-0 w-100" align-h="center">
                                        <b-button-group size="sm"
                                                        class="m-1 btn-gray-light rounded-pill border border-gray">
                                            <b-button :pressed="data.Periodicity == 0" v-b-tooltip.hover
                                                      @click="data.Periodicity = 0; changeData(data.DataId)" pill
                                                      :class="data.Periodicity == 0? 'bg-white text-'+Variant :''"
                                                      :variant="'outline-white'">
                                                {{$t('Total')}}
                                            </b-button>
                                            <b-button :pressed="data.Periodicity == 1" v-b-tooltip.hover
                                                      @click="data.Periodicity = 1; changeData(data.DataId)" pill
                                                      :class="data.Periodicity == 1? 'bg-white text-'+Variant :''"
                                                      variant="outline-white">
                                                {{$t('Day')}}
                                            </b-button>
                                            <b-button :pressed="data.Periodicity == 2" v-b-tooltip.hover
                                                      @click="data.Periodicity = 2; changeData(data.DataId)" pill
                                                      :class="data.Periodicity == 2? 'bg-white text-'+Variant :''"
                                                      variant="outline-white">
                                                {{$t('Hour')}}
                                            </b-button>
                                            <b-button :pressed="data.Periodicity == 3" v-b-tooltip.hover
                                                      @click="data.Periodicity = 3; changeData(data.DataId)" pill
                                                      :class="data.Periodicity == 3? 'bg-white text-'+Variant :''"
                                                      variant="outline-white">
                                                {{$t('Minute')}}
                                            </b-button>
                                        </b-button-group>
                                    </b-col>
                                    <b-col class="m-0 p-0"></b-col>
                                    <b-col class="m-0 p-0"></b-col>
                                    <b-col class="m-0 p-0"></b-col>
                                </b-row>
                            </b-card>
                            <b-card body-class="m-0 p-0 pt-3" class="bg-transparent" :title="$t('Value')" title-tag="h6">
                                <b-row class="w-100 h-100 m-0 p-0" align-v="center">
                                    <b-col class="m-0 p-0">
                                        <b-form-input required :id="$id('value')" v-model="data.Value" type="number"
                                                      size="sm" @change="changeData(data.DataId)">
                                        </b-form-input>
                                    </b-col>
                                    <b-col md="auto" class="pl-2 pr-3 m-0 p-0"><b>{{ data.Unit }}</b></b-col>
                                </b-row>
                            </b-card>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-form>
            <template #modal-footer="{ cancel }">
                <!-- Bouton pour Supprimer les valeurs d'un facteur d'influence -->
                <b-button :variant="'outline-' + Variant" class="ml-1" pill @click.stop="cancel()">
                    {{ $t('Cancel') }}
                </b-button>
                <!-- Bouton pour Modifier les valeurs d'un facteur d'influence -->
                <b-button :variant="Variant"
                          class="ml-1" pill @click.stop="saveChange();"
                          :disabled="changeModalData.length == 0 && !$store.getters['CheckAction']('Write', undefined, Action)">
                    {{ $t('Apply') }}
                </b-button>
                <!-- Bouton pour Supprimer les valeurs d'un facteur d'influence -->
                <b-button variant="danger" class="ml-1" pill @click.stop="deleteData()"
                          :disabled="!$store.getters['CheckAction']('Delete', undefined, Action)"
                          v-if="showDatas.length == 1 && showDatas[0].Status != 0">
                    {{ $t('Clear') }}
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>

<script lang="ts">

import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import FactorCalendarSemester from "./FactorCalendarSemester.vue";
import FactorCalendarMonth from "./FactorCalendarMonth.vue";
import FactorCalendarWeek from "./FactorCalendarWeek.vue";
import FactorCalendarDay from "./FactorCalendarDay.vue";
import {FactorUtils} from "./FactorUtils";
import FactorCalendarTypeEnum from "@/enums/FactorCalendarTypeEnum";
import {mixins} from "vue-class-component";
import locales from '../locales/FactorCalendar.json';

@Component({
    methods: {},
    components: {
        FactorCalendarSemester,
        FactorCalendarMonth,
        FactorCalendarWeek,
        FactorCalendarDay
    },
    i18n:{messages: locales}
})

export default class FactorCalendar extends mixins(Vue, FactorUtils) {

    @Prop()
    public Variant: string;

    /** Droit disponible pour l'utilisateur en cours */
    @Prop()
    public Action!: string;

    /** Données du facteur sur cette période */
    @Prop()
    public Data!: any[];

    /** Premières Données du facteur en dehors de la période */
    @Prop()
    public OuterData!: any[];

    /** Pour l'affichage des données survolées */
    private hoverDatas: any[] = [];

    /** Type de calendrier : semester - month - week - day */
    @Prop()
    public CalendarType: FactorCalendarTypeEnum;

    @Prop()
    public SelectedDate: Date;

    /** Facteur sélectionné */
    @Prop({ default: () => {} })
    public SelectedFactor!: any;

    @PropSync("StartPeriod")
    public startPeriod: moment.Moment;
    @PropSync("EndPeriod")
    public endPeriod: moment.Moment;

    /** Pour accéder à l'enum dans la partie template */
    private factorCalendarTypeEnum = FactorCalendarTypeEnum;

    /** Validité de la journée */
    //private dayValid: boolean = null;

    /** Couleur des données */
    private colorCaclulateData: string = 'tertiary';
    private colorNotCaclulateData: string[] = ['primary'];

    /** Pour la modal */
    @PropSync("ShowModal", { default : () => false})
    public showModal: boolean;
    @PropSync("ShowDatas", { default : () => []})
    public showDatas: {
        NoMonth: number, NoDay: number, Status: number, DataId?: number, StartDate?: string,
        StartTime?: string, EndDate?: string, EndTime?: string, Periodicity?: number,
        Value?: number, Unit: string, Collapsed: boolean, StartNoDay: number; EndNoDay: number,
        StartNoHour: number; EndNoHour: number
    } [];

    /**
     * Pour connaitre la couleur des temporalités
     * @private
     */
    @Watch('SelectedFactor', {immediate: true})
    private updateSelectedFactor() {
        if (this.SelectedFactor?.FactorType != 2)
            this.colorNotCaclulateData = ['quartary', 'secondary-middle-light', 'secondary-dark', 'secondary'];
        else
            this.colorNotCaclulateData = ['primary', 'primary', 'primary', 'primary'];
    }

    /** Suppression d'une donnée */
    public deleteData(dataId) {
        console.debug('FactorCalendar.vue - deleteData - dataId : ', dataId);

        let a = this.showDatas.find(a => a.DataId == dataId);
        if (dataId != undefined && a != undefined) {
            this.changeData(dataId);
            a.Status = -1;
        } else {
            for (let i = 0; i < this.showDatas.length; ++i) {
                this.showDatas[i].Status = -1;
            }
            Vue.set(this, 'showModal', false);
            this.$emit('emitSave', this.showDatas);
        }
    }

    /** Application des données modifiées/ajoutées/supprimées */
    private saveChange() {
        let canUpdate = true;
        console.debug('FactorCalendar.vue - saveChange - this.showDatas : %O', this.showDatas);

        /** Verification des valeurs */
        for (let i = 0; i < this.showDatas.length; i++) {
            let value = this.showDatas[i];

            if (this.SelectedFactor?.Temporality != 1) {
                //** La date de fin n'est pas demandée. Elle est identique à la date de début. */
                value.EndDate = value.StartDate;
                value.EndTime = value.StartTime;
            }

            /** Remise à jour de numéro de date et de mois */
            if (value.StartTime == undefined && value.StartDate != undefined){
                value.StartTime = "00:00:00";
            }
            if (value.EndTime == undefined && value.EndDate != undefined){
                value.EndTime = "00:00:00";
            }
            if (value.StartDate != undefined && value.StartTime != undefined && value.StartDate + value.StartTime != "") {
                let startDate = this.getMomentDate(value.StartDate + " " + value.StartTime);
                value.NoMonth = this.getDateToNumber(startDate, 'month');
                value.NoDay = this.getDateToNumber(startDate, 'day');
                value.StartNoHour = this.getDateToNumber(startDate, 'minute');
                value.StartNoDay = this.getDateToNumber(startDate, 'day');
            } else {
                value.NoDay = 1;
                value.NoMonth = 1;
                value.StartDate = "0001-01-01";
                value.StartTime = "00:00:00";
                value.StartNoDay = 0;
                value.StartNoHour = 0;
            }
            /** Mise à la bonne valeur les dates infinies */
            if (value.EndDate != undefined && value.EndTime != undefined && value.EndDate + value.EndTime != "") {
                let endDate = this.getMomentDate(value.EndDate + " " + value.EndTime);
                value.EndNoHour = this.getDateToNumber(endDate, 'minute');
                value.EndNoDay = this.getDateToNumber(endDate, 'day');
            } else {
                value.EndDate = "9999-12-31";
                value.EndTime = "23:59:59.9999999";
                value.EndNoDay = 99991231;
                value.EndNoHour = 999912312359;
            }

            // Une valeur doit être présente
            if (value.Value == undefined) {
                canUpdate = false;
                this.$bvToast.toast(this.$t('PleaseEnterValue').toString(), { // $t('PleaseEnterValue') / "Veuillez renseigner une valeur."
                    title: this.$t('Error').toString(), // $t('Errror') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
            // La date de début doit être inférieure ou égale à la date de fin
            else if (value.StartNoHour > value.EndNoHour) {
                canUpdate = false;
                this.$bvToast.toast(this.$t('EndDateError').toString(), { // $t('EndDateError') / La date de fin doit être supérieure à la date de début
                    title: this.$t('Error').toString(), // $t('Errror') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
            // La date de début doit être strictement inférieure à la date de fin dans le cas d'un facteur temporelle
            else if (this.SelectedFactor.Temporality == 1 /* Valeur temporelle */ &&  value.StartNoHour == value.EndNoHour) {
                canUpdate = false;
                this.$bvToast.toast(this.$t('DateSelectionError').toString(), { // $t('DateSelectionError') / Une valeur temporelle doit contenir une période. Veuillez indiquer une date de fin différente à celle de début.
                    title: this.$t('Error').toString(), // $t('Errror') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
            // la valeur doit être dans la période d'affichage
            else {
                let startPeriodNoHour = this.startPeriod.year() * 100000000 + (this.startPeriod.month() + 1) * 1000000
                    + this.startPeriod.date() * 10000 + this.startPeriod.hours() * 100 + this.startPeriod.minutes();
                let endPeriodNoHour = this.endPeriod.year() * 100000000 + (this.endPeriod.month() + 1) * 1000000
                    + this.endPeriod.date() * 10000 + this.endPeriod.hours() * 100 + this.endPeriod.minutes();

                if (value.EndNoHour > startPeriodNoHour || value.StartNoHour < endPeriodNoHour ||
                    (value.StartNoHour < startPeriodNoHour && value.EndNoHour > endPeriodNoHour)) {
                //if (((value.StartNoHour == 0) || (value.StartNoHour != 0 && startPeriodNoHour <= value.StartNoHour))
                //    && ((value.EndNoHour == 999912312359) || (value.EndNoHour != 999912312359 && endPeriodNoHour >= value.EndNoHour))) {
                    // Application possible.
                    canUpdate = canUpdate || true;
                }
                else {
                    canUpdate = false;
                    this.$bvToast.toast(this.$t('ValueNotDefinedError').toString(), { // $t('ValueNotDefinedError') / La valeur n'est pas définie dans la période affichée dans le calendrier. Veuillez la saisir dans un calendrier contenant la période.
                        title: this.$t('Error').toString(), // $t('Errror') / "Erreur"
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                }
            }
        }

        if (canUpdate) {
            Vue.set(this, 'showModal', false);
            this.$emit('emitSave', this.showDatas);
        }
    }

    /** Afin d'indiquer dans la modale si une modification a été faite. */
    private changeModalData: number[] = [];
    /** Permet de mettre le bouton en couleur pour indiquer un changement de données */
    private changeData(dataId) {
        if (dataId == undefined) {
            this.changeModalData = [];
        }
        else if (this.changeModalData.findIndex(a => a == dataId) == -1) {
            this.changeModalData.push(dataId);
        }
        console.debug('FactorCalendar.vue - changeData - dataId : %O - changeModalData : %O', dataId, this.changeModalData);
    }
}
</script>
<style scoped>

/** Style pour afficher dans le tooltip la flèche de droite */
:deep(.right-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
}

/** Style pour afficher dans le tooltip la flèche du bas */
:deep(.top-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(50% 0, 0 100%, 100% 100%);
}

/** Style pour afficher dans le tooltip la flèche de gauche */
:deep(.left-arrow) {
    position: relative;
    right: -1px;
    width: 15px !important;
    clip-path: polygon(100% 100%, 100% 0, 0 50%);
}

/** Style pour afficher dans le tooltip la flèche du haut */
:deep(.bottom-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(100% 0, 0 0, 50% 100%);
}

</style>